import { render, staticRenderFns } from "./JobBlogTable.vue?vue&type=template&id=4d486be5&"
import script from "./JobBlogTable.vue?vue&type=script&lang=js&"
export * from "./JobBlogTable.vue?vue&type=script&lang=js&"
import style0 from "./JobBlogTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports